const Nav = () => (
  <nav
    data-testid="main-nav"
    className="sticky top-0 z-50 border-b border-[#E7E5E4] bg-[#FAF8F5]/90 backdrop-blur-md"
  >
    <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
      <a href="#top" data-testid="nav-logo" className="flex items-center gap-3 group">
        <svg
          className="w-6 h-6 text-[#9A3412] transition-transform duration-300 group-hover:rotate-90"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <circle cx="12" cy="12" r="10" stroke="#78350F" />
          <path d="M12 6v12M6 12h12" stroke="#9A3412" />
        </svg>
        <span className="text-xl font-bold tracking-tight text-[#1C1917] font-serif-display">
          Brim.
        </span>
      </a>
      <div className="flex items-center gap-6">
        <a
          href="#how-it-works"
          data-testid="nav-protocol-link"
          className="text-xs font-semibold tracking-widest uppercase text-stone-600 hover:text-stone-900 transition-colors hidden sm:block"
        >
          Protocol
        </a>
        <a
          href="#interest-form"
          data-testid="nav-request-access-btn"
          className="inline-flex items-center justify-center px-4 py-2 text-xs font-bold uppercase tracking-wider text-white bg-[#1C1917] hover:bg-stone-800 rounded transition-colors"
        >
          Request Access
        </a>
      </div>
    </div>
  </nav>
);

export default Nav;
